
import React, { useState, useEffect } from "react";
import {
  KeyboardArrowLeft, KeyboardArrowRight, PlaceOutlined, CalendarMonthOutlined,
  AccessAlarmOutlined, ExpandMore, ExpandLess, NotificationsActiveOutlined,
  Close,
} from "@mui/icons-material";
import { Accordion, AccordionSummary, AccordionDetails, IconButton, Modal, Backdrop, } from "@mui/material";
import ShareButton from "../../../../../../components/shareButton/shareButton";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import moment from "moment";
import { primeraFecha, SIN_DATO } from "../../../../../../utils/evento";
import { api } from "../../../../../../services/api";
import { sanitizarHtml } from "../../../../../../utils/sanitizarHtml";
import SponsorsMobile from "./SponsorsMobile";


const ContentMobile = ({ data }) => {
  const fechaPrincipal = primeraFecha(data);
  const [showMap, setShowMap] = useState(false);
  const [mapUrl, setMapUrl] = useState("");

  const direccion = [data?.direccion, data?.ciudad, data?.provincia].filter(Boolean).join(" ");
  useEffect(() => {
    const fetchMapData = async () => {
      if (direccion) {
        try {
          const response = await api.maps.getEmbedURL(direccion);

          if (response.status === "success") {
            setMapUrl(response.embedUrl);
          } else {
            console.error("Error al obtener el mapa:", response.message);
          }
        } catch (error) {
          console.error("Error al obtener el mapa:", error);
        }
      }
    };

    fetchMapData();
  }, [direccion]);

  const toggleMap = () => {
    setShowMap(!showMap);
  };

  const imagesDescrip = data?.attachs?.filter(
    (attach) => !attach.avatar && !attach.banner
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesDescrip.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + imagesDescrip.length) % imagesDescrip.length
    );
  };

  const handleNextExpanded = (e) => {
    e.stopPropagation();
    setExpandedIndex((prevIndex) => (prevIndex + 1) % imagesDescrip.length);
  };

  const handlePrevExpanded = (e) => {
    e.stopPropagation();
    setExpandedIndex(
      (prevIndex) =>
        (prevIndex - 1 + imagesDescrip.length) % imagesDescrip.length
    );
  };

  const handleExpandImage = (index) => {
    setExpandedIndex(index);
  };

  const handleCloseImage = () => {
    setExpandedIndex(null);
  };

  const currentExpandedImage = expandedIndex !== null ? imagesDescrip[expandedIndex] : null;

  const showControls = imagesDescrip?.length > 1;

  return (
    <div className="pt-2 p-4 d-flex flex-column gap-4">

      {/*TITULO*/}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h2 className="fs-1 fw-bold m-0" style={{ color: "#221a60" }}>
          {data.evento}
        </h2>

        <ShareButton
          idEvento={data.id}
          eventoNombre={data.evento}
          sx={{
            color: "white",
          }}
        />
      </div>

      {/*UBICACION Y FECHA*/}
      <div className="d-flex flex-wrap gap-4">
        {data.fechas?.length > 1 ? (
          <div className="mr-5">
            <h4 className="fs-3" style={{ color: "#221a60" }}>
              Fechas
            </h4>
            {data.fechas.map((fecha) => (
              <>
                <p className="mb-0 d-flex gap-2">
                  <CalendarMonthOutlined />{" "}
                  {format(new Date(fecha.fecha), "d 'de' MMMM", {
                    locale: es,
                  })}
                </p>
                <p className="mb-2 d-flex gap-2">
                  <AccessAlarmOutlined />{" "}
                  {moment.parseZone(fecha.hora_inicio).format("HH:mm")} hs.
                </p>
              </>
            ))}
          </div>
        ) : (
          <div className="mr-5">
            <h4 className="fs-3" style={{ color: "#221a60" }}>
              Fecha
            </h4>
            <p className="mb-2 d-flex gap-2">
              <CalendarMonthOutlined />{" "}
              {fechaPrincipal
                ? format(new Date(fechaPrincipal.fecha), "d 'de' MMMM", { locale: es })
                : SIN_DATO}
            </p>
            <p className="m-0 d-flex gap-2">
              <AccessAlarmOutlined />{" "}
              {fechaPrincipal
                ? `${moment.parseZone(fechaPrincipal.hora_inicio).format("HH:mm")} hs.`
                : SIN_DATO}
            </p>
          </div>
        )}

        <div className="mr-5">
          <h4 className="fs-3" style={{ color: "#221a60" }}>
            Ubicación
          </h4>

          <div className="d-flex gap-2">
            <PlaceOutlined />
            <div>
              <p className="m-0 fw-bold">{data.direccion}</p>
              <p className="my-2 text-secondary">{data.ciudad}</p>
              <span
                onClick={() => setShowMap(!showMap)}
                style={{ color: "#5656ff", cursor: "pointer" }}
              >
                Mostrar mapa{" "}
                {!showMap ? (
                  <ExpandMore fontSize="small" />
                ) : (
                  <ExpandLess fontSize="small" />
                )}
              </span>
            </div>
          </div>
        </div>

        {/* Mapa */}
        {showMap && (
          <div className="w-100">
            <iframe
              title="location"
              width="100%"
              height="250"
              id="map"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={mapUrl}
              style={{
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            />
          </div>
        )}
      </div>

      {/*DESCRIPCION*/}
      <div>
        <h4 className="fs-3" style={{ color: "#221a60" }}>
          Acerca del evento
        </h4>
        <span
          className="descripcion-unstyled"
          dangerouslySetInnerHTML={{
            __html: sanitizarHtml(data?.descripcion),
          }}
        />
        <div
          style={{
            position: "relative",
            maxWidth: "500px",
            margin: "auto",
            overflow: "hidden",
            marginTop: "10px",
          }}
        >
          {showControls && (
            <IconButton
              style={{
                position: "absolute",
                border: "none",
                cursor: "pointer",
                padding: "10px",
                zIndex: 1,
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#5656FF",
              }}
              onClick={handlePrev}
            >
              <KeyboardArrowLeft />
            </IconButton>
          )}
          <div
            style={{
              display: "flex",
              transition: "transform 0.5s ease",
              width: "100%",
              transform: `translateX(-${currentIndex * 100}%)`,
            }}
          >
            {imagesDescrip?.map((attach, index) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: "100%",
                  boxSizing: "border-box",
                  cursor: attach.type === "image" ? "pointer" : "default",
                }}
                key={index}
                onClick={() => attach.type === "image" && handleExpandImage(index)}
              >
                {attach.type === "image" ? (
                  <img
                    src={attach.url}
                    alt={`Imagen ${index}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: window.innerWidth > 768 ? "700px" : "600px",
                      objectFit: "contain",
                    }}
                  />
                ) : attach.type === "video" ? (
                  <video
                    controls
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "500px",
                      objectFit: "contain",
                    }}
                  >
                    <source src={attach.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : null}
              </div>
            ))}
          </div>
          {showControls && (
            <IconButton
              style={{
                position: "absolute",
                border: "none",
                cursor: "pointer",
                padding: "10px",
                zIndex: 1,
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                color: "#5656FF",
              }}
              onClick={handleNext}
            >
              <KeyboardArrowRight />
            </IconButton>
          )}
          {showControls && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                position: "absolute",
                bottom: "10px",
                width: "100%",
              }}
            >
              {imagesDescrip.map((_, index) => (
                <div
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  style={{
                    width: "10px",
                    height: "10px",
                    margin: "0 5px",
                    borderRadius: "50%",
                    backgroundColor:
                      currentIndex === index ? "#5656FF" : "#ddd",
                    cursor: "pointer",
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/*PREGUNTAS FRECUENTES*/}
      {data.FAQ && data.FAQ.length > 0 && (
        <div>
          <h5 className="fs-3" style={{ color: "#221a60" }}>
            Preguntas frecuentes
          </h5>
          {data.FAQ?.map((faq) => (
            <Accordion key={faq.id} style={{ backgroundColor: "#f9f9f9" }}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel${faq.id}-content`}
                id={`panel${faq.id}-header`}
              >
                <p className="m-0 fw-medium">{faq.pregunta}</p>
              </AccordionSummary>

              <AccordionDetails
                className="m-0 descripcion-unstyled"
                style={{ whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{ __html: sanitizarHtml(faq.respuesta) }}
              />
            </Accordion>
          ))}
        </div>
      )}
      <SponsorsMobile sponsors={data?.sponsors} />

      <Modal
        open={expandedIndex !== null}
        onClose={() => { }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.9)' },
          onClick: (e) => e.stopPropagation()
        }}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            handleCloseImage();
          }
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
          }}
        >
          <IconButton
            onClick={handleCloseImage}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 2,
            }}
          >
            <Close />
          </IconButton>

          {showControls && (
            <>
              <IconButton
                onClick={handlePrevExpanded}
                style={{
                  position: 'absolute',
                  left: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#5656ff',
                  backgroundColor: 'transparent',
                  zIndex: 2,
                }}
              >
                <KeyboardArrowLeft fontSize="large" />
              </IconButton>

              <IconButton
                onClick={handleNextExpanded}
                style={{
                  position: 'absolute',
                  right: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#5656ff',
                  backgroundColor: 'transparent',
                  zIndex: 2,
                }}
              >
                <KeyboardArrowRight fontSize="large" />
              </IconButton>
            </>
          )}

          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {currentExpandedImage && currentExpandedImage.type === "image" && (
              <img
                src={currentExpandedImage.url}
                alt={`Imagen ${expandedIndex + 1}`}
                style={{
                  maxWidth: '95%',
                  maxHeight: '85vh',
                  objectFit: 'contain',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                  borderRadius: '8px',
                }}
              />
            )}
          </div>

          <div
            style={{
              position: 'absolute',
              bottom: '30px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <div
              style={{
                color: 'white',
                fontSize: '16px',
                fontFamily: "Bricolage Grotesque",
                textShadow: '0 2px 4px rgba(0,0,0,0.8)',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                padding: '8px 16px',
                borderRadius: '20px',
              }}
            >
              {expandedIndex + 1} / {imagesDescrip.length}
            </div>

            {showControls && (
              <div style={{ display: 'flex', gap: '8px' }}>
                {imagesDescrip.map((_, index) => (
                  <div
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpandedIndex(index);
                    }}
                    style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: expandedIndex === index ? '#5656FF' : 'rgba(255, 255, 255, 0.5)',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      border: expandedIndex === index ? '2px solid white' : 'none',
                    }}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContentMobile;